import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  company_name: "Udhyog Tech",
  office_address: "",
  contact_number: "",
  support_email: "",
  support_whatsapp_number: "",
  office_hours: "",
  facebook_url: "",
  instagram_url: "",
  linkedin_url: "",
  youtube_url: "",
  footer_tagline: "",
};

const SettingsContext = createContext({ settings: DEFAULTS, refreshSettings: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refreshSettings = () => {
    api.get("/settings/public").then((res) => setSettings({ ...DEFAULTS, ...res.data })).catch(() => {});
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  return <SettingsContext.Provider value={{ settings, refreshSettings }}>{children}</SettingsContext.Provider>;
};

export const useCompanySettings = () => useContext(SettingsContext);
